// Shiny Pretty Quiz Carousel
(function ($) {
  Drupal.behaviors.shinyPrettyQuizFormatterV1 = {
    attach: function (context) {
      var $quizCarousel = $('.js-shiny-pretty-quiz-formatter-v1', context);
      var $questionsCarousel = $('.js-pretty-options-carousel', context);
      var $quizSlideAnswers = $('.js-pretty-quiz-questions-answers', $quizCarousel);
      var $startBtn = $('.js-pretty-quiz-start', $quizCarousel);
      var $slideBack = $('.js-pretty-quiz-questions-back', $quizCarousel);
      var $slideNext = $('.js-pretty-quiz-questions-next', $quizCarousel);
      var isMobile = false;

      // Set Quiz Carousel
      function setQuizCarousel() {
        $quizCarousel.unslick().slick({
          speed: 300,
          infinite: false,
          arrows: false,
          swipe: false,
          lazyLoad: 'progressive'
        });

        // Start Button
        $startBtn.once().on('click', function (event) {
          event.preventDefault();
          $quizCarousel.slickGoTo(1, true);
        });

        // Back Button
        $slideBack.once().on('click', function (event) {
          event.preventDefault();
          $quizCarousel.slickPrev();
        });

        // Answers Mouse Event
        $quizSlideAnswers.once().on('mouseover', function () {
          slideHover($(this), 1);
        }).on('mouseout', function () {
          slideHover($(this), 0);
        });

        function slideHover($slide, isHover) {
          var $quizSlide = $slide.closest('.js-quiz-slide');
          var $quizAnswers = $quizSlide.find('.js-pretty-quiz-questions-answers');
          var $quizSlideNext = $quizSlide.find('.js-pretty-quiz-questions-next');

          if (isMobile) {
            $quizAnswers.removeClass('selected');
            $slide.addClass('selected');
            $quizSlideNext.addClass('active');
          }
          if (isHover) {
            $quizAnswers.removeClass('active').addClass('inactive');
            $slide.removeClass('inactive').addClass('active');
          } else {
            $quizAnswers.removeClass('inactive active');
          }
        }
        // Answers Event
        $quizSlideAnswers.once('questions-select').on('click', function (event) {
          event.preventDefault();
          var $quizSlide = $(this).closest('.js-quiz-slide');
          var $quizAnswers = $quizSlide.find('.js-pretty-quiz-questions-answers');
          var $quizSlideNext = $quizSlide.find('.js-pretty-quiz-questions-next');

          $quizSlide.addClass('selected');
          $quizAnswers.removeClass('selected');
          $(this).addClass('selected');
          $quizSlideNext.addClass('active');
          if (!isMobile) {
            setResultSlide($quizSlide);
          }
        });

        // Next Button
        $slideNext.once().on('click', function (event) {
          event.preventDefault();
          var $quizSlide = $(this).closest('.js-quiz-slide');

          if ($(this).hasClass('active')) {
            setResultSlide($quizSlide);
          }
        });
      }

      // Set Result Slide
      function setResultSlide($quizSlide) {
        var $quizAnswers = $quizSlide.find('.js-pretty-quiz-questions-answers.selected');

        if (!$quizSlide.hasClass('view-result')) {
          $quizCarousel.slickNext();
        } else {
          var $answer = $quizAnswers.attr('data-result');
          var $answerSlide = $('.js-shiny-pretty-result-' + $answer).closest('.js-pretty-formatter-slide');
          var $answerSlideIndex = $answerSlide.attr('index');

          if ($answerSlideIndex) {
            $quizCarousel.slickGoTo($answerSlideIndex, true);
          }
        }
      }

      // Set Questions Carousel
      function setSubCarousel() {
        isMobile = !(parseInt(Unison.fetch.now().width) >= parseInt(Unison.fetch.all()['usn-x-large'], 10));
        if (isMobile) {
          if (!$questionsCarousel.hasClass('slick-initialized')) {
            $questionsCarousel.unslick().slick({
              speed: 300,
              infinite: false,
              arrows: true,
              dots: true
            });
          }
        } else if ($questionsCarousel.hasClass('slick-initialized')) {
          $questionsCarousel.unslick();
          $questionsCarousel.removeAttr('style');
        }
      }

      $(window).resize(_.debounce(function () {
        setSubCarousel();
      }, 250));

      $(window).on('load', function () {
        $('body').addClass('shiny-pretty-quiz');
        $quizCarousel.removeClass('hidden');
        setSubCarousel();
        setQuizCarousel();
      });
    }
  };
})(jQuery);
